import React from 'react';
import '../../styles/table-main/main.css';
import { Link } from 'react-router-dom';

const Main = () => {
    return (
        <div id='pdfCardMain'>
            <div className="pdf-card-main pt-5">
                <div className="container py-4">
                    <div className="container">
                        <h2 className="text-left my-heading">
                            About ITEP
                        </h2>
                        <p className="text-left">The four-year Integrated Teacher Education Programme (ITEP) aims to develop passionate, motivated, and professionally trained educators who are well-prepared to create and deliver age-appropriate, engaging learning experiences across various stages of school education. This programme is committed to providing aspiring teachers with a high-quality education that integrates strong content knowledge, effective pedagogy, core values, and practical teaching skills.</p>
                        <div className="col-md-12 pull-left flip sm-pull-none">
                        <div className="admin-table">
                            <div className="table-scrollable">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>S.no</th>
                                            <th>Course name</th>
                                            <th>Seats</th>
                                            <th>Duration</th>
                                            <th>Nature</th>
                                            <th>Admission Eligibility</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>1</td>
                                            <td>B.A.B.Ed</td>
                                            <td>1 unit (50 seats)</td>
                                            <td>4 years</td>
                                            <td>Regular</td>
                                            <td>As per NCTE Norms</td>
                                        </tr>
                                        <tr>
                                            <td>2</td>
                                            <td>B.Sc.B.Ed</td>
                                            <td>1 unit (50 seats)</td>
                                            <td>4 years</td>
                                            <td>Regular</td>
                                            <td>As per NCTE Norms</td>
                                        </tr>
                                        

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Main;